<template>
	<div>
		<div>
			<!-- <button class="drawer-button" @click.stop="toggleDrawer">☰</button> -->
			<div class="drawer-content">
				<div class="cdcss">
					<div
						class="navMoblie Level1"
						v-for="(item, index) in level1TableData"
						:key="index"
					>
					<template v-if="item.text == '政策法规库'">
							<a v-if="item.isnav" href="https://edu.drcnet.com.cn/maillist?dt=d"
								:target="item.uid == 'A708' ? '_blank' : ''"
								>校长决策参考</a>
							<div v-if="item.uid == 'A705'" class="triangleOne"></div>
						</template>
						<template v-else>
							<a :href="item.uid == 'A710' ? '/custom' : '/custom' + item.url" :target="item.uid == 'A708' ? '_blank' : ''"
								v-if="item.uid != 'A705'">{{
									item.text }}</a>
						</template>
						<!-- <a
							:href="item.uid == 'A710' ? '/' : item.url"
							:target="item.uid == 'A708' ? '_blank' : ''"
							v-if="item.uid != 'A705'"
							>{{ item.text }}</a
						> -->
					</div>
					<div class="navMoblie Level1"><span>重点专题库</span></div>
					<div
						class="paddingcss"
						v-for="(items, indexs) in tableData"
						:key="indexs"
					>
						<div class="navMoblie">
							<span>{{ items.text }}</span>
						</div>
						<ul class="one_menu">
							<li>
								<div>
									<ul class="two_menu">
										<li
											v-for="(
												item, index
											) in items.children"
											:key="index"
										>
											<a
												v-if="item.isnav"
												:href="
													getAlink(
														item.url,
														item.uid,
														item
													)
												"
												@click="gotoLink(item)"
												>{{ item.text }}</a
											>
										</li>
									</ul>
									<div class="clear"></div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { getNav } from '../../api/home';
import { Popup, Cell, CellGroup, Collapse, CollapseItem, Divider } from 'vant';
import { mapState } from 'vuex';
export default {
	name: 'homeNav',
	components: {
		Popup,
		Cell,
		CellGroup,
		Collapse,
		CollapseItem,
		Divider,
	},
	mixins: [],
	props: {},
	data() {
		return {
			activeName: this.$route.name,
			leftNavList: [],
			isMoblie: false,
			tableData: [
				{
					"uid": "A70520",
					"relativetypeid": "NoRelative",
					"text": "创新",
					"apptext": null,
					"children": [
						{
							"uid": "A7052044",
							"relativetypeid": "Channel",
							"text": "中国式现代化",
							"apptext": null,
							"children": [
								{
									"uid": "A705204401",
									"relativetypeid": "Leaf",
									"text": "高层论述",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29166",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204402",
									"relativetypeid": "Leaf",
									"text": "权威视点",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29167",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204403",
									"relativetypeid": "Leaf",
									"text": "动态实践",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29168",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204404",
									"relativetypeid": "Leaf",
									"text": "理论研究",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29169",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204405",
									"relativetypeid": "Leaf",
									"text": "政策规划",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29170",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204406",
									"relativetypeid": "Channel",
									"text": "精选内容",
									"apptext": null,
									"children": [
										{
											"uid": "A70520440601",
											"relativetypeid": "Leaf",
											"text": "现代化经济体系",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 10,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29171",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440602",
											"relativetypeid": "Leaf",
											"text": "产业现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 20,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29172",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440603",
											"relativetypeid": "Leaf",
											"text": "农业农村现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 30,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29173",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440609",
											"relativetypeid": "Leaf",
											"text": "人口现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 31,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29221",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440604",
											"relativetypeid": "Leaf",
											"text": "教育现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 40,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29174",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440608",
											"relativetypeid": "Leaf",
											"text": "科技现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 50,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29205",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440605",
											"relativetypeid": "Leaf",
											"text": "国家治理现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 60,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29175",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440606",
											"relativetypeid": "Leaf",
											"text": "城市现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 70,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29176",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440607",
											"relativetypeid": "Leaf",
											"text": "生态现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 80,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29177",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										}
									],
									"orderStatus": null,
									"webchanneltypeid": 20,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 0,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "",
									"chnIds": "7322",
									"isleaf": false,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 1,
							"isnav": true,
							"url": "/list",
							"shownew": true,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "29166,29167,29168,29169,29170,29171,29172,29173,29174,29175,29176,29177,29205,29221",
							"chnIds": "7321",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052001",
							"relativetypeid": "Leaf",
							"text": "高质量发展",
							"apptext": null,
							"children": [],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 2,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "30238",
							"chnIds": "",
							"isleaf": true,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052033",
							"relativetypeid": "channel",
							"text": "创新驱动",
							"apptext": "创新发展",
							"children": [
								{
									"uid": "A705203301",
									"relativetypeid": "Leaf",
									"text": "中央精神",
									"apptext": "中央精神",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "chenlu@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "23055",
									"chnIds": "5825",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": "2192",
									"hotWords": null
								},
								{
									"uid": "A705203302",
									"relativetypeid": "Leaf",
									"text": "各地举措",
									"apptext": "各地举措",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "chenlu@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "23056",
									"chnIds": "5825",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": "2192",
									"hotWords": null
								},
								{
									"uid": "A705203303",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": "动态视点",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "chenlu@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "23057",
									"chnIds": "5825",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": "2192",
									"hotWords": null
								},
								{
									"uid": "A705203304",
									"relativetypeid": "Leaf",
									"text": "理论探讨",
									"apptext": "理论探讨",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "chenlu@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "23058",
									"chnIds": "5825",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": "2192",
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 3,
							"isnav": true,
							"url": "/list",
							"shownew": null,
							"email": "chenlu@drcnet.com.cn",
							"listType": 0,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "5825",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": "2192",
							"hotWords": null
						},
						{
							"uid": "A7052046",
							"relativetypeid": "Channel",
							"text": "新质生产力",
							"apptext": null,
							"children": [
								{
									"uid": "A705204601",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29695",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204602",
									"relativetypeid": "Leaf",
									"text": "专家探析",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29696",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204603",
									"relativetypeid": "Leaf",
									"text": "地方实践",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29697",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204604",
									"relativetypeid": "Leaf",
									"text": "深度研究",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29698",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204605",
									"relativetypeid": "Leaf",
									"text": "政策参考",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29699",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204606",
									"relativetypeid": "Leaf",
									"text": "国际视角",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29724",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 4,
							"isnav": true,
							"url": "/list",
							"shownew": true,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7482",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},

						{
							"uid": "A7052004",
							"relativetypeid": "Channel",
							"text": "数字经济",
							"apptext": null,
							"children": [
								{
									"uid": "A705200401",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 1,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29145",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705200402",
									"relativetypeid": "Leaf",
									"text": "理论探讨",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 3,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29146",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705200403",
									"relativetypeid": "Leaf",
									"text": "实践案例",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 4,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29273",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 6,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7692",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 1,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				},
				{
					"uid": "A70521",
					"relativetypeid": "NoRelative",
					"text": "协调",
					"apptext": null,
					"children": [
						{
							"uid": "A7052105",
							"relativetypeid": "Channel",
							"text": "区域协同发展",
							"apptext": null,
							"children": [
								{
									"uid": "A705210501",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 1,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30241",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705210502",
									"relativetypeid": "Leaf",
									"text": "权威视点",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 2,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30242",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705210503",
									"relativetypeid": "Leaf",
									"text": "深度分析",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 3,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30243",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 21,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7693",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052116",
							"relativetypeid": "Channel",
							"text": "粤港澳大湾区",
							"apptext": "地方产业集群",
							"children": [
								{
									"uid": "A705211601",
									"relativetypeid": "Leaf",
									"text": "建设进展",
									"apptext": "地方动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 30,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "hujie.li@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": "",
									"tags": null,
									"location": null,
									"leafIds": "24986",
									"chnIds": "6293",
									"isleaf": false,
									"locations": null,
									"frequency": null,
									"products": "2005,2053",
									"hotWords": null
								},
								{
									"uid": "A705211602",
									"relativetypeid": "Leaf",
									"text": "权威视角",
									"apptext": "地方动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 30,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "hujie.li@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": "",
									"tags": null,
									"location": null,
									"leafIds": "24987",
									"chnIds": "6293",
									"isleaf": false,
									"locations": null,
									"frequency": null,
									"products": "2005,2053",
									"hotWords": null
								},
								{
									"uid": "A705211603",
									"relativetypeid": "Leaf",
									"text": "深度分析",
									"apptext": "地方动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 30,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "hujie.li@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": "",
									"tags": null,
									"location": null,
									"leafIds": "24988",
									"chnIds": "6293",
									"isleaf": false,
									"locations": null,
									"frequency": null,
									"products": "2005,2053",
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 28,
							"isnav": true,
							"url": "/list",
							"shownew": null,
							"email": "hujie.li@drcnet.com.cn",
							"listType": 0,
							"level": 4,
							"tagIds": "",
							"tags": null,
							"location": null,
							"leafIds": "24986,24987,24988",
							"chnIds": "6293",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052197",
							"relativetypeid": "Leaf",
							"text": "海洋经济",
							"apptext": "海洋经济",
							"children": [],
							"orderStatus": null,
							"webchanneltypeid": 30,
							"introduction": null,
							"ordernumber": 35,
							"isnav": true,
							"url": "/list",
							"shownew": null,
							"email": "hujie.li@drcnet.com.cn",
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "30272",
							"chnIds": "",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": "53",
							"hotWords": null
						}
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 2,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				},
				{
					"uid": "A70522",
					"relativetypeid": "NoRelative",
					"text": "绿色",
					"apptext": null,
					"children": [
						{
							"uid": "A7052203",
							"relativetypeid": "Leaf",
							"text": "生态文明",
							"apptext": null,
							"children": [],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 41,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "30240",
							"chnIds": "",
							"isleaf": true,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						
						{
							"uid": "A7052207",
							"relativetypeid": "Channel",
							"text": "绿色发展",
							"apptext": "节能环保产业",
							"children": [
								{
									"uid": "A705220701",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": "最新动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18527",
									"chnIds": "4799",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705220702",
									"relativetypeid": "Leaf",
									"text": "研究报告",
									"apptext": "研究报告",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18528",
									"chnIds": "4799",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705220703",
									"relativetypeid": "Leaf",
									"text": "政策法规",
									"apptext": "政策法规",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18529",
									"chnIds": "4799",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 43,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": "27",
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "4799",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052211",
							"relativetypeid": "Channel",
							"text": "新能源产业",
							"apptext": "新能源产业",
							"children": [
								{
									"uid": "A705221101",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": "最新动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18540",
									"chnIds": "4803",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705221102",
									"relativetypeid": "Leaf",
									"text": "研究报告",
									"apptext": "研究报告",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18541",
									"chnIds": "4803",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705221103",
									"relativetypeid": "Leaf",
									"text": "政策法规",
									"apptext": "政策法规",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18542",
									"chnIds": "4803",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 45,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": "27",
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "4803",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						}
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 3,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				},
				{
					"uid": "A70523",
					"relativetypeid": "NoRelative",
					"text": "开放",
					"apptext": null,
					"children": [
						{
							"uid": "A7052309",
							"relativetypeid": "Leaf",
							"text": "对外开放",
							"apptext": null,
							"children": [
								{
									"uid": "A705230901",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 1,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "22240,22241",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705230902",
									"relativetypeid": "Leaf",
									"text": "运行数据",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 2,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30250",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705230903",
									"relativetypeid": "Leaf",
									"text": "分析研究",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 3,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "22242,22243",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 51,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "22240,22241,30250,22242,22243",
							"chnIds": "",
							"isleaf": true,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 4,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				},
				{
					"uid": "A70524",
					"relativetypeid": "NoRelative",
					"text": "共享",
					"apptext": null,
					"children": [
						{
							"uid": "A7052443",
							"relativetypeid": "Channel",
							"text": "共同富裕",
							"apptext": null,
							"children": [
								{
									"uid": "A705244301",
									"relativetypeid": "Leaf",
									"text": "前沿进展",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29162",
									"chnIds": "7320",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705244302",
									"relativetypeid": "Leaf",
									"text": "专家观点",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29163",
									"chnIds": "7320",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705244303",
									"relativetypeid": "Leaf",
									"text": "理论研究",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29164",
									"chnIds": "7320",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705244304",
									"relativetypeid": "Leaf",
									"text": "政策参考",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29165",
									"chnIds": "7320",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 61,
							"isnav": true,
							"url": "/list",
							"shownew": true,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7320",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052401",
							"relativetypeid": "Leaf",
							"text": "中华民族共同体",
							"apptext": null,
							"children": [],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 64,
							"isnav": true,
							"url": "/list",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "30325",
							"chnIds": "7691",
							"isleaf": true,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052410",
							"relativetypeid": "Channel",
							"text": "优秀传统文化",
							"apptext": null,
							"children": [
								{
									"uid": "A705241001",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 1,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30252",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705241002",
									"relativetypeid": "Leaf",
									"text": "深度分析",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 2,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30253",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 67,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7698",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						}
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 5,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				}
			],
			level1TableData: [],
		};
	},
	computed: { ...mapState(['homeNavList']) },
	watch: {
		MobileVerification: {
			handler(to) {
				// console.log(to);
				this.isMoblie = this.MobileVerification;
				// this.isMobileVt();
				// this.isMobileValue();
			},
			immediate: true,
		},
	},
	mounted() {
		this.activeName = this.$route.name;
		this.getNavs();
	},
	methods: {
		getNavs() {
			let top = this.$store.state.homeNavList;
			this.level1TableData = top;
			// this.tableData = top.find((item) => item.uid == 'A705').children;
			// this.tableData.unshift({
			// 	isnav: true,
			// 	text: '首页',
			// 	uid: '000',
			// });
			console.log(top);
			// 	// const data = getNav({ version: 'A2' });
			// 	getNav({ uid: 'A7', depth: '0' }).then((res) => {
			// 		this.leftNavList = res.data.data;
			// 		// this.updateHomeNavList(res.data.data);
			// 		// localStorage.removeItem('leftNavList');
			// 		// localStorage.setItem(
			// 		// 	'leftNavList',
			// 		// 	JSON.stringify(res.data.data)
			// 		// );
			// 		for (let index = 0; index < res.data.data.length; index++) {
			// 			const element = res.data.data[index];
			// 			console.log(element);
			// 			if (element.uid == 'A705') {
			// 				this.tableData = element.children;
			// 			}
			// 		}
			// 		this.tableData.unshift({
			// 			isnav: true,
			// 			text: '首页',
			// 			uid: '000',
			// 		});
			// 	});
		},
		gotoLink(item) {
			this.$eventBus.$emit('upLists', item.uid);
			this.$eventBus.$emit('isDrawer', false);
		},
		//导航上的跳转链接-打开新页跳转的
		getAlink(url, uid, item) {
			var returnUrl = 'javascript:void(0);';
			if (
				this.$route.name != 'specialTopicNoLeft' &&
				item.children.length <= 0 &&
				item.tagIds == null
			) {
				returnUrl = '/custom/specialTopicNoLeft?uid=' + uid;
			}

			if (
				this.$route.name != 'specialTopic' &&
				(item.children.length > 0 || item.tagIds != null)
			) {
				returnUrl = '/custom/specialTopic?uid=' + uid;
			}

			return returnUrl;
		},
		//打开抽屉
		// toggleDrawer() {
		// 	this.isDrawerOpen = !this.isDrawerOpen;
		// },
	},
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 769px) {
	.nav {
		width: 0 !important;
	}
}
.nav {
	width: 100%;
	min-width: 1200px;
	height: 45px;
	display: flex;
	line-height: 45px;
	background: #015293 url('../../assets/homeImage/navbj.jpg') repeat-x;
}
.nobackground {
}
.homeNavs {
	width: 1200px;
	max-width: 1200px;
	margin: 0 auto;
}
.nav .homeNavs .ul1 li {
	float: left;
}
.nav .homeNavs .ul1 li a {
	color: #fff;
	padding-right: 57px;
	font-size: 17px;
}
.nav .homeNavs .ul2 li {
	float: left;
}
.nav .homeNavs .ul2 li a {
	color: #fff;
	padding-right: 26px;
	font-size: 14px;
}
.nav .homeNavs li a:hover,
.nav .homeNavs li a.on {
	color: #ffe400;
}
</style>
<!-- 手机端样式 -->
<style scoped lang="less">
.drawer-button {
	position: fixed;
	top: 20px;
	left: 20px;
	background: transparent;
	border: none;
	cursor: pointer;
	font-size: 24px;
	z-index: 100; /* 更高的层级 */
}
.cdcss {
	// margin: 10px 0;
	background: #fff;
	position: relative;
	// .paddingcss {
	// 	padding: 0 10px;
	// }
	.navMoblie {
		border-bottom: 1px solid #ececec;
		position: relative;
		padding: 10px 10px 0 10px;
		margin: 0 15px;
		span {
			font-size: 16px;
			color: #1a1a1a;
			height: 35px;
			line-height: 35px;
			position: relative;
			display: block;
		}
		a {
			font-size: 16px;
			height: 35px;
			line-height: 35px;
			color: #1a1a1a;
			padding: 6px 10px;
			border: 1px solid #f1f1f1;
			border-radius: 10px;
		}
	}
	.Level1 {
		border-bottom: none;
		margin-bottom: -10px;
		margin-left: 5px;
		span {
			// font-weight: 600;
		}
		a {
			// font-weight: 600;
			border: none;
			padding: 0;
		}
	}
	.navMoblieFirst {
		border-bottom: none;
		margin-bottom: -20px;
	}
	.all_menu {
		width: 100%;
		font-size: 16px;
		white-space: nowrap;
		overflow: auto;
		padding: 10px 0;
		a {
			color: #474747;
			padding-left: 15px;
			padding-right: 15px;
			border-right: 1px solid #eaeaea;
			text-decoration: none;
		}
		a:nth-child(1) {
			padding-left: 0px;
		}
		a:link,
		a:visited,
		a:active {
			color: #363636;
			text-decoration: none;
			cursor: pointer;
		}
	}
	.one_menu {
		padding: 10px;
		.acss {
			font-size: 20px;
			color: #474747;
			margin: 15px 0;
			display: block;
			background: url(../../assets/special/conlefticon.jpg) no-repeat left
				3px;
			height: 15px;
			padding-left: 16px;
		}
		.two_menu {
			a {
				font-size: 12px;
				color: #474747;
				display: block;
				float: left;
				padding: 6px 8px;
				border: 1px solid #f1f1f1;
				border-radius: 20px;
				margin: 5px;
			}
		}

		a:link,
		a:visited,
		a:active {
			color: #363636;
			text-decoration: none;
			cursor: pointer;
		}
	}
}
</style>
